import React, { memo, useCallback, useRef, useState, useMemo } from 'react';
import { Flex } from '@chakra-ui/react';
import { AutocompleteInput, Button, MaskInput, TextInput, Unform, Icon } from 'components';
import { debounce } from 'utils/debounce';
import { FormHandles } from '@unform/core';
import { objToQuery, queryToObj } from 'utils/query';
import { routePaths } from 'constants/routes';
import { RouteComponentProps } from 'react-router';
import { colors } from 'theme/colors';
import { ESIMULATION } from 'constants/simulation';
import { DownloadBtn } from './sytles';
import { generateReportSimulatedFines } from 'services/Simulator';
import { openNotification } from 'utils/notification';

interface IProps {
  history: RouteComponentProps['history'];
}
interface IFormData {
  filtro: string;
  status: string;
  origem: string;
}

export const ToolbarComponent: React.FC<IProps> = ({ history }) => {
  const formRef = useRef<FormHandles>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [dateRangeError, setDateRangeError] = useState<boolean>(false);
  const [isloading, setisloading] = useState<boolean>(false);

  const { filtro, status, origem, periodoInicial, periodoFinal } = useMemo(() => {
    return queryToObj(history.location.search) as {
      filtro?: string;
      status?: string;
      origem?: string;
      periodoInicial?: string;
      periodoFinal?: string;
    };
  }, [history.location.search]);

  const handleSearch = useCallback(() => {
    const formData = formRef.current?.getData() as IFormData;

    const query = objToQuery({ ...formData, page: 0 });

    history.replace(`${routePaths.simulatedFines}?${query}`);
  }, []);

  const handleDownloadReport = async (): Promise<void> => {
    setisloading(true);
    const searchData = history.location.search.replace('page=0&', '');

    try {
      const { data: res } = await generateReportSimulatedFines(searchData);
      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'relatorio.xlsx');
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (err: any) {
      if (err?.message.includes('400')) {
        openNotification('Não há simulações para o período informado.', 'error');
      }
    } finally {
      setisloading(false);
    }
  };

  return (
    <Unform
      initialData={{ filtro, status, origem, periodoFinal, periodoInicial }}
      formRef={formRef}
    >
      <Flex mt="1rem" gridGap="1rem" mb="1rem" maxH="40px" justify="space-between">
        <TextInput
          width="18rem"
          name="filtro"
          notErrorMargin
          backgroundColor="#fff"
          leftIcon={{ name: 'search', color: 1100 }}
          placeholder="Pesquisar"
          onInput={debounce(handleSearch, 500)}
          onKeyPress={(ev: any) => {
            const keyCode = ev.keyCode ? ev.keyCode : ev.which ? ev.which : ev.charCode;
            if (keyCode === 13) {
              if (ev.stopPropagation) {
                ev.stopPropagation();
                ev.preventDefault();
              }
            }
          }}
        />

        <AutocompleteInput
          name="origem"
          placeholder="Origem"
          onSelectOption={debounce(handleSearch, 100)}
          options={[
            { label: 'DPO', value: ESIMULATION.DPO },
            { label: 'Landing Page', value: ESIMULATION.LP },
          ]}
        />
        <MaskInput
          leftIcon="calendar"
          name="periodoInicial"
          mask="period"
          placeholder="Período inicial ___/___"
          notErrorMargin
          parseDate
          onChange={debounce(handleSearch, 1000)}
          hasError={dateRangeError}
        />
        <MaskInput
          placeholder="Período final  ___/___"
          leftIcon="calendar"
          name="periodoFinal"
          mask="period"
          notErrorMargin
          parseDate
          onChange={debounce(handleSearch, 1000)}
          hasError={dateRangeError}
        />

        <DownloadBtn
          onClick={() => handleDownloadReport()}
          type="button"
          variant="secondary"
          outline
          isLoading={isloading}
        >
          <Icon name="download" size={1.3} />
          <p>Relatório</p>
        </DownloadBtn>
        <Flex>
          <Button
            type="button"
            href={routePaths.fineSimulator}
            style={{ background: colors.brand.white, width: '9rem' }}
            outline
          >
            Simular multa
          </Button>
        </Flex>
      </Flex>
    </Unform>
  );
};
export const Toolbar = memo(ToolbarComponent);
